import { getAIHook } from '@openclassrooms/data-connect-web/utils';

const useEnhancePersonalProjectDescription = getAIHook({
  promptCode: 'enhance-personal-project-description',
  serverName: 'ai-api-user',
});

export default useEnhancePersonalProjectDescription;
